import React from 'react'
import '../Styles/GetInvolvedPage2.scss';

function GetInvolvedPage2() {
   return(
      <div className="getInvolvedPage2Content">
         <div className="getInvolvedPage2Container">
            <div className="getInvolvedPage2highSchool">
               <div className="getInvolvedPage2KitchenWork">
                  <div className="getInvolvedPage2KitchenWorkTitle">
                     High School Program
                  </div>
                  <div className="getInvolvedPage2KitchenWorkContent">
                     These are young men between the ages of 15-19 who volunteer a part <br></br>
                     of their summer to assist the ministry of Camp Connect. They serve <br></br>
                     as dining hall support staff during a month-long session in the summer. <br></br>
                     Two sessions are available to choose from
                  </div>
               </div>

               <div className="getInvolvedPage2CampIntern">
                  <div className="getInvolvedPage2CampInternTitle">
                     Camp Internship Program
                  </div>
                  <div className="getInvolvedPage2CampInternContent">
                     The Camp Internship is a two-week program for High School Juniors, <br></br>
                     Seniors, and Graduates. The goal of Camp Internship is to instruct <br></br>
                     and challenge young people with real-life ministry in a fun and <br></br>
                     team-spirited atmosphere. Understanding the importance of a Christ-centered<br></br>
                     philosophy of ministry will further prepare young people for future ministry<br></br>
                  </div>
               </div>
            </div>
            <div className="getInvolvedPage2College">
               <div className="getInvolvedPage2SummerStaff">
                  <div className="getInvolvedPage2SummerStaffTitle">
                     Summer Staff 2023
                  </div>
                  <div className="getInvolvedPage2SummerStaffDescription">
                     Christian young people who have completed two semesters in a Christian college may be able to work at the Camp Connect as counselors.<br></br>
                     One of the finest privileges summer staff counselors will have is counseling those who respond in the services. Come experience the <br></br>
                     greatest summer of your life!
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}
export default GetInvolvedPage2;